import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="chip">{{ text() }}</span>`,
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  /** Texto del chip */
  text = input<string>('Label');

  /** Color del texto (CSS válido) */
  textColor = input<string>('#ffffff');

  /** Color de fondo (CSS válido) */
  bgColor = input<string>('#0b4f91');

  // Exponer como CSS vars en el :host
  @HostBinding('style.--chip-text') get cssText() {
    return this.textColor();
  }

  @HostBinding('style.--chip-bg') get cssBg() {
    return this.bgColor();
  }
}